import { 
	UPDATE_ACTION_ITEM,
	SHOW_TAMAGUI_CARD,
	HIDE_TAMAGUI_CARD,
	TOGGLE_TAMAGUI_CARD,
	SET_TAMAGUI_CARD_VISIBILITY,
	ADD_ACTION,
	REMOVE_ACTION,
	SET_ACTIONS,
} from './types';

export enum ModalActionTypes {
	ShowModal,
	HideModal,
}

export enum LocationTypes {
	Web,
	Mobile,
}

export interface ModalSettings {
	heading: string;
	subHeading: string;
	type: ModalActionTypes;
	location: LocationTypes;
}

export function updateActionItem(vals: any, index: number) {
	const hasVal = vals.length > 0;
	console.log('ACTION UPDATED', vals);
	return {
		type: UPDATE_ACTION_ITEM,
		payload: {
			element: {
				...vals[0],
			},
			index: index,
		},
	};
}

export function updateGlobal(obj: any) {
	console.log('updating global');
	console.log(obj);
	return { type: 'UPDATE_GLOBAL', payload: obj };
}

export function deleteElementButton(index: number) {
	return { type: 'DELETE_ELEMENT', payload: index };
}

export const showModal = (settings: ModalSettings) => {
	return {
		type: 'SHOW_MODAL',
		payload: settings,
	};
};

export const hideModal = () => {
	return {
		type: 'HIDE_MODAL',
	};
};

export function showPasteboardData() {
	return {
		type: 'SHOW_PASTEBOARD_DATA',
	};
}

export function hidePasteboardData() {
	return {
		type: 'HIDE_PASTEBOARD_DATA',
	};
}

export function showPasteboardTitleEdit() {
	return {
		type: 'SHOW_PASTEBOARD_TITLE_EDIT',
	};
}

export function hidePasteboardTitleEdit() {
	return {
		type: 'HIDE_PASTEBOARD_TITLE_EDIT',
	};
}

export function updateCurrentPasteboardTitle(title: string) {
	return {
		type: 'UPDATE_CURRENT_PASTEBOARD_TITLE',
		payload: title,
	};
}

export function setCurrentDataset(data: any) {
	console.log('SETTING CURRENT DATASET', data);
	return {
		type: 'SET_CURRENT_DATASET',
		payload: data,
	};
}

export function showTamaguiCard() {
	return {
		type: SHOW_TAMAGUI_CARD,
	};
}

export function hideTamaguiCard() {
	return {
		type: HIDE_TAMAGUI_CARD,
	};
}

export function toggleTamaguiCard() {
	return {
		type: TOGGLE_TAMAGUI_CARD,
	};
}

export function setTamaguiCardVisibility(visible: boolean) {
	return {
		type: SET_TAMAGUI_CARD_VISIBILITY,
		payload: { visible },
	};
}

// Action Management Actions
export function addAction(actionData: any, index?: number) {
	return {
		type: ADD_ACTION,
		payload: { actionData, index },
	};
}

export function removeAction(index: number) {
	return {
		type: REMOVE_ACTION,
		payload: { index },
	};
}

export function setActions(actions: any[]) {
	return {
		type: SET_ACTIONS,
		payload: actions,
	};
}
